import { Empty } from "zhs-components";
import CardHeader from "../../components/CardHeader.vue";
export default {
  props: {
    menu: Object
  },
  components: {
    Empty,
    CardHeader
  },

  created() {
    // this.getNewsList();
    this.getNewsClassifyList();
  },

  watch: {
    classifyId(val) {
      console.log(val, 'classifyId');

      if (val) {
        this.getNewsList();
      }
    }

  },

  data() {
    return {
      newsList: [],
      newsCenterList: [],
      mainRecommendNews: null,
      classifyList: [],
      classifyId: "",
      hiddenMoreClass: true,
      currentIndex: 0
    };
  },

  methods: {
    // scrollLeft(){
    //   this.$$refs.category.scrollLeft
    // },
    scroll(direction) {
      const containerWidth = this.$refs.category.offsetWidth;

      if (direction === 'left') {
        this.currentIndex = Math.max(this.currentIndex - 1, 0);
      } else if (direction === 'right') {
        this.currentIndex = Math.min(this.currentIndex + 1, this.classifyList.length - 1);
      }

      this.$refs.category.scrollLeft = this.currentIndex * containerWidth;
    },

    async getNewsList() {
      this.mainRecommendNews = null;
      this.newsList = [];
      const res = (await this.$http.getHomeNews({
        num: this.menu.num,
        menu_id: this.menu.id,
        classify_id: this.classifyId
      })) || [];
      console.log("新闻-首页", res); // if (res.length && res[0].news_cover_url) {
      //   this.mainRecommendNews = res.shift();
      //   this.newsCenterList = res.splice(0, 2)
      //   console.log(this.mainRecommendNews);
      // }
      // console.log(res.shift(),this.newsList,'res.shift();')

      if (res.length) {
        this.mainRecommendNews = res.shift();
        this.newsList = res;
      }
    },

    async getNewsClassifyList() {
      const res = await this.$http.getNewsClassify({
        menu_id: this.menu.id
      });
      console.log("getNewsClassifyList", res);
      this.classifyList = res;

      if (res && res.length) {
        this.classifyId = res[0].id;
      }
    },

    searchCourseList(id) {
      this.classifyId = id; // this.getNewsList();
    }

  }
};